import React from 'react';
import { css } from '@compiled/react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives';

import { ErrorDetail } from '@confluence/error-boundary/entry-points/ErrorDetail.ts';

import SearchErrorImage from './images/SearchErrorImage.svg';

export const i18n = defineMessages({
	errorHeader: {
		id: 'home.views.error.header',
		// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "We're having trouble getting your results",
		description:
			'Header that appears on a Home View when an error occurs during initial load or searching/filtering.',
	},
	errorAction: {
		id: 'home.views.error.action',
		defaultMessage: 'Refresh and try again.',
		description:
			'Action text that appears on a Home View when an error occurs during initial load or searching/filtering.',
	},
});

const errorContainerStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '68px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	width: '100%',
});

const errorHeaderStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '37px',
});

export const Error = () => (
	<div css={errorContainerStyles}>
		<img src={SearchErrorImage} alt="" />
		{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
		<h3 css={errorHeaderStyles}>
			<FormattedMessage {...i18n.errorHeader} />
		</h3>
		<Box paddingBlockStart="space.200">
			<FormattedMessage {...i18n.errorAction} />
		</Box>
		<Box paddingBlockStart="space.200">
			<ErrorDetail />
		</Box>
	</div>
);
